const env = {
    dev: {
        name: 'dev',
        api_url: 'https://api.dev.theworkinggenius.link/api',
        sm_api: 'https://dev.thestaffmatcher.link',
        base_url: 'https://dev.theworkinggenius.link',
        ttg_url: 'https://app.dev.thetablegroup.link',
        ttg_api: 'https://app.dev.thetablegroup.link/api',
        robots: 'noindex',
    },
    stage: {
        name: 'stage',
        api_url: 'https://api.stage.theworkinggenius.link/api',
        sm_api: 'https://stage.thestaffmatcher.link',
        base_url: 'https://stage.theworkinggenius.link',
        ttg_url: 'https://app.stage.thetablegroup.link',
        ttg_api: 'https://app.stage.thetablegroup.link/api',
        robots: 'noindex',
    },
    prod: {
        name: 'prod',
        api_url: 'https://api.workinggenius.com/api',
        sm_api: 'https://workinggenius.ai',
        base_url: 'https://www.workinggenius.com',
        ttg_url: 'https://www.tablegroup.com',
        ttg_api: 'https://www.tablegroup.com/api',
        robots: 'noindex',
    },
};

const config = env['###_REACT_APP_ENV_###' || 'dev'] || env.dev;
export default config;
